import { SearchSortField, SearchSortDirection, BillingPeriod } from '@benefitsui/app/api/benefits-clients';

export const Constants = {
  ActionsText: 'Actions',
  AmountKey: 'amount',
  AmountText: 'Amount',
  BillGroupKey: 'billGroup',
  BillGroup: 'Bill group',
  CloseText: 'Close',
  CurrencyUsdKey: 'USD',
  DataKey: 'data',
  dueDate: 'Due date',
  amountBalance: 'Estimated due',
  invoicePeriod: 'Invoice period',
  InvoiceKey: 'invoice',
  InvoicePeriodKey: 'invoicePeriod',
  InvoicePeriodAndNumberText: 'Invoice period & number',
  InvoiceText: 'Invoice',
  ListKey: 'list',
  LocaleEnglishUs: 'en-US',
  NameText: 'Name',
  PolicyIdKey: 'PolicyId',
  premiumCalc: 'Premium calculation',
  RunDateText: 'Run date',
  SortKey: 'sort',
  statement: 'Statement #',
  StatusText: 'Status',
  StringEmpty: '',
  UnspecifiedText: 'Unspecified'
};


export interface CellItemType {
  actions?: string;
  amountBalance: number,
  amountBalanceUI?: string,
  amountPaid: number;
  amountTotal: number;
  billGroupName: string;
  billGroupNumber: string;
  billType: string,
  dueDate: string,
  dueDateObj?: DueDateObj,
  invoicePeriod?: string
  mostRecentPremiumId: string,
  premiumCalc: string,
  premiumCalcObj?: PremiumCalcObj,
  premiumCalcUpdatedDate: string,
  statementStartDate: string,
  statementEndDate: string,
  statementNumber: string,
  statementPDFURI: string,
  selected?: boolean,
  secondNoticeDays: number,
  thirdNoticeDays: number
}

export interface PremiumCalcObj {
  text: string,
  color: string,
  appendix?: string,
  link?: string,
  linkText?: string,
  variant: string,
  icon: string,
  matStyle: string
}

export interface DueDateObj {
  text: string,
  color: string,
  appendix?: string,
  link?: string,
  linkText?: string,
  variant: string,
  icon: string
}

export type BillingListSearchParameters = {
  page: number;
  pageSize: number;
  billGroupNumber: string | undefined;
  status: string | undefined;
  invoicePeriod: BillingPeriod | undefined;
  invoicePeriodString: string | undefined;
  sortField: SearchSortField;
  sortDirection: SearchSortDirection;
};

export type PaymentSearchParameters = {
  page: number;
  pageSize: number;
  sortField: SearchSortField;
  sortDirection: SearchSortDirection;
};
